import { lazy, Suspense } from "react";
import classNames from "classnames";
import url from "url/index";
import { SEO } from "utils/helmet/components/SEO";

import "./styles.sass";

const LazyLandingAviatorPartnersContainer = lazy(
  () => import("containers/molecules/LandingAviatorPartnersContainer"),
);
const LazyAviatorLandingContentContainer = lazy(
  () => import("containers/molecules/AviatorLandingContentContainer"),
);

const Aviator = () => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const logoClass = classNames("Aviator__logo_glory", {
    banger: VITE_APP_PROJECT_NAME === "banger",
  });
  return (
    <>
      <SEO
        pathname={`/${url.config.landing.root}/${url.config.landing.aviator}`}
      />
      <div className="Aviator">
        <div className="Aviator__logo" />
        <div className={logoClass} />
        <div className="Aviator__girl_right" />
        <div className="Aviator__red_plane" />
        <div className="Aviator__blue_smoke" />
        <div className="Aviator__pink_plane" />
        <Suspense fallback="">
          <LazyAviatorLandingContentContainer />
        </Suspense>
        <div className="Aviator__partners">
          <Suspense fallback="">
            <LazyLandingAviatorPartnersContainer />
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default Aviator;
